// Site
export const CROWN_COPYRIGHT_TEXT = '© Crown copyright';
export const OPENS_IN_NEW_TAB = '(opens in new tab)';
export const RETURN_TO_VOYAGE_PLANS = 'Return to voyage plans';
export const SERVICE_NAME =
  'Tell Border Force and HMRC you are sailing to or from the UK in a pleasure craft';

// Account
export const USER_NOT_VERIFIED_STATUS_MESSAGE = 'User not verified, please verify registration';

export const EDIT_ACCOUNT = {
  CHANGE_NAME: 'You have changed your name',
  CHANGE_NUMBER: 'You have changed your number',
};

export const PAGE_STATE = {
  CHECK_CREATE_ACCOUNT: 'createAccountCheck',
  ACCOUNT: 'account',
  DETAILS_CHANGE_FROM_CHECK: 'detailsChangeFromCheck',
};

// Contact information
export const SUPPORT_EMAIL = 'spcr@homeoffice.gov.uk';
export const PC_HMRC_EMAIL = 'pleasurecraft.lcsouth@hmrc.gov.uk';
export const YACHTLINE_NUMBER = '0300 123 2012';
export const BF_CONTACT_NUMBER_PDF_DATE_OF_CHANGE = '2026-08-12';
export const BF_CENTRAL_NUMBER = '+44 (0)300 106 5509';
export const BF_NORTH_NUMBER = '+44 (0)300 104 5941';
export const BF_SOUTH_EAST_NUMBER = '+44 (0)1303 299 157';

export const BF_BRISTOL_NUMBER = '+44 (0)1275 473 757';
export const BF_DEVON_AND_CORNWALL_NUMBER = '+44 (0)1752 689200';
export const BF_NEWHAVEN_NUMBER = '+44 (0)1273 865936 / 865937';
export const BF_POOLE_NUMBER_1 = '+44 (0)1202 634 555';
export const BF_POOLE_HOURS_1 = '8am to 10pm';
export const BF_PORTSMOUTH_NUMBER = '+44 (0)7356 308792 / 07356 308786';
export const BF_SOUTH_WALES_NUMBER = '+44 (0)1446 712920';
export const BF_WEST_WALES_NUMBER = '+44 (0)1646 623023';
export const BF_SOUTHAMPTON_NUMBER = '+44 (0)7880 054 844';
export const UK_BF_CARRIER_SUP_HUB = '0300 369 0610';
export const INT_BF_CSH_PHONE = '+44 204 619 6020';
export const PC_UNIT_OF_EXPERTISE = '03000 516 864';

// Customs
export const VAT_NOT_DUE_REASONS = [
  'Returned Goods Relief',
  'Temporary Admission Relief',
  'Transfer of Residence Relief',
  'Inward Processing',
];

// Error messages
export const ERROR_MESSAGES = {
  GENERIC_ERROR: 'Something went wrong',
};

// Forms
export const AUTOCOMPLETE_DIALCODE = 'dialCode';
export const SESSION_USE_DEFAULT_LABEL = 'useDefault';
export const TEXTAREA_MAX_CHAR = '250';

// Pleasure Craft form
export const ADD_A_PLEASURE_CRAFT_TEXT = 'Add a pleasure craft';
export const MOTORBOAT_TEXT = 'Motorboat';
export const SAILING_BOAT_TEXT = 'Sailing boat';
export const REGISTRATION_FIELD_NAME = 'registrationCountryName';
export const UNREGISTERED_CRAFT = 'Unregistered';
export const MAX_MOORING_LENGTH = 200;
export const MAX_PLEASURE_CRAFT_NAME_LENGTH = 35;
export const MAX_PLEASURE_CRAFT_TYPE_LENGTH = 35;
export const MAX_PORT_NAME_LENGTH = 35;
export const MAX_REGISTRATION_NUMBER_LENGTH = 15;

// Interstitial page
export const INFO_COOKIE_NAME = 'INFO_VERSION';
export const INFO_VERSION = '2'; // update this to force user to see interstitial on next sign in
export const INFO_COOKIE_AGE = 365 * 24 * 60 * 60; // 365 times 24 times 60 times 60

// People
export const PERSON_TYPE_EMPLOYEE = 'Crew';
export const PERSON_TYPE_PASSENGER = 'Passenger';
export const DOCUMENT_ISSUING_STATE_FIELD_NAME = 'documentIssuingState';
export const NATIONALITY_FIELD_NAME = 'nationality';

// Reports
export const PAGE_SIZE_PARAM = 'per_page=10';
export const CONTINUE_ONLY = 'continueOnly';
export const EDITING_VOYAGE_TYPE = 'edit';
export const NEW_VOYAGE_TYPE = 'new';
export const VOYAGE_PAGE_TYPE_SELECTOR = 'selectorPage';
export const SUBMITTED_VOYAGE_STATUS = 'Submitted';

// Status tags
export const STATUS_TAG_CANNOT_START = 'cannotStartYet';
export const STATUS_TAG_COMPLETED = 'completed';
export const STATUS_TAG_INCOMPLETE = 'incomplete';
export const STATUS_TAG_IN_PROGRESS = 'inProgress';
export const STATUS_TAG_READY_TO_VIEW = 'readyToView';
export const STATUS_TAG_UPT_NOT_REQUIRED = 'notRequired';

// UPT scenarios
export const UPT_STATUS_DEPARTURE = 'departure';
export const UPT_STATUS_SECTION_ONE_INCOMPLETE = 'sectionOneIncomplete';
export const UPT_STATUS_ERROR_SYSTEM = 'systemError';
export const UPT_STATUS_IN_PROGRESS = 'inProgress';
export const UPT_STATUS_0T_LAST = 'LAST';
export const UPT_STATUS_0T_IN_PROGRESS = '0TinProgress';
export const UPT_STATUS_0T_FIRST = '0TFirst';
export const UPT_STATUS_CHECKS_REQUIRED = 'checksRequired';
export const UPT_STATUS_ERROR_DATA = 'dataError';
export const UPT_STATUS_UPT_SEEN = 'uptSeen';
export const UPT_STATUS_RESULTS_READY = 'uptResultsReady';
export const UPT_STATUS_ERROR_USERDATA = 'errorUserData';
export const UPT_CONNECTION_ERROR_CODE = '408';

// UPT 0T retry states
export const UPT_0T_RETRY_STATE_FIRST = 'FIRST';
export const UPT_0T_RETRY_STATE_INTERMEDIATE = 'INTERMEDIATE';
export const UPT_0T_RETRY_STATE_LAST = 'LAST';

// Various Actions
export const ACTION_CHECKIN = 'actionCheckin';
export const ACTION_NAVIGATE = 'actionNavigate';
export const ACTION_ERROR = 'actionError';
export const ACTION_IN_PROGRESS = 'actionInProgress';
export const ACTION_READY = 'actionReady';
export const LINK_ACTIVE = 'linkActive';
export const LINK_DISABLED = 'linkDisabled';

// Voyage
export const UPT_CHECKS_REQUIRED_NO = 'uptChecksRequiredFalse';
export const UPT_CHECKS_REQUIRED_YES = 'uptChecksRequiredTrue';
export const UPT_RESPONSE_AUTHORITY_TO_CARRY_GRANTED = 'AUTHORITY TO CARRY GRANTED';
export const UPT_RESPONSE_VALID_PERMISSION_TO_TRAVEL = 'VALID PERMISSION TO TRAVEL';
export const UPT_RESPONSE_NO_RECORD = 'NO RECORD OF VALID PERMISSION TO TRAVEL';
export const UPT_SYSTEM_TIME_OUT = 'SYSTEM TIME OUT';
export const UPT_PERMISSION_TO_TRAVEL_ERROR =
  'Sorry, there is a problem processing the permission to travel checks';
export const VOYAGE_START_FALLBACK_API_ERROR_MESSAGE =
  'Error starting voyage plan. Please try clicking Continue again.';
export const DEPARTURE_SAME_AS_ARRIVAL_ERROR =
  'Your departure point must not be the same as your arrival point';

export const VOYAGE_STATUSES = {
  CANCELLED: 'Cancelled',
  DRAFT: 'Draft',
  FAILED: 'Failed',
  PRE_CANCELLED: 'PreCancelled',
  PRE_SUBMITTED: 'PreSubmitted',
  SUBMITTED: 'Submitted',
};

export const EMPTY_STATE_MESSAGES = {
  [VOYAGE_STATUSES.DRAFT]: 'You do not have any draft voyages.',
  [VOYAGE_STATUSES.SUBMITTED]: 'You do not have any submitted voyages.',
  [VOYAGE_STATUSES.CANCELLED]: 'You do not have any cancelled voyages.',
};
